// Entfernbare Chips (z. B. eingeladene Teilnehmer): Text, optionales Status-Icon, X zum Entfernen.
import type { ReactNode } from 'react';
import { X } from '@phosphor-icons/react';
import { FORM, INNEN } from './form-stil';

export interface FormChip { key: string; label: string; zusatz?: ReactNode; entfernenLabel: string; onEntfernen: () => void }

export function FormChips({ chips }: { chips: readonly FormChip[] }) {
  if (!chips.length) return null;
  return (
    <div className="flex flex-wrap" style={{ gap: 6 }}>
      {chips.map(c => (
        <span key={c.key} className="pf-drop flex items-center" style={{
          gap: 6, height: 32, padding: '0 6px 0 12px', borderRadius: 999, background: INNEN.flaeche,
          boxShadow: 'inset 0 0 0 0.5px rgba(226,192,141,0.4)', fontSize: 12.5, fontWeight: 700, color: FORM.text,
        }}>
          <span className="truncate" style={{ maxWidth: 220 }}>{c.label}</span>
          {c.zusatz}
          <button type="button" onClick={c.onEntfernen} aria-label={c.entfernenLabel} data-tip={c.entfernenLabel}
            className="flex cursor-pointer items-center justify-center rounded-full border-none"
            style={{ width: 22, height: 22, background: 'rgba(255,255,255,0.12)', color: FORM.text }}>
            <X size={10} weight="bold" />
          </button>
        </span>
      ))}
    </div>
  );
}
